/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_Item_ProfileInputs */

const en_us2_profile_editors_export_item_profile = /** @type {(inputs: Profile_Editors_Export_Item_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your profile and training routine`)
};

const pt_br2_profile_editors_export_item_profile = /** @type {(inputs: Profile_Editors_Export_Item_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu perfil e sua rotina de treino`)
};

const es_419_profile_editors_export_item_profile = /** @type {(inputs: Profile_Editors_Export_Item_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu perfil y tu rutina de entrenamiento`)
};

const pt_pt2_profile_editors_export_item_profile = /** @type {(inputs: Profile_Editors_Export_Item_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu perfil e a tua rotina de treino`)
};

const fr_fr2_profile_editors_export_item_profile = /** @type {(inputs: Profile_Editors_Export_Item_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton profil et ton rythme d'entraînement`)
};

const de_de2_profile_editors_export_item_profile = /** @type {(inputs: Profile_Editors_Export_Item_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Profil und deine Trainingsroutine`)
};

const it_it2_profile_editors_export_item_profile = /** @type {(inputs: Profile_Editors_Export_Item_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo profilo e la tua routine di allenamento`)
};

/**
* | output |
* | --- |
* | "Your profile and training routine" |
*
* @param {Profile_Editors_Export_Item_ProfileInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_item_profile = /** @type {((inputs?: Profile_Editors_Export_Item_ProfileInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_Item_ProfileInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_item_profile(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_item_profile(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_item_profile(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_item_profile(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_item_profile(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_item_profile(inputs)
	return en_us2_profile_editors_export_item_profile(inputs)
});
export { profile_editors_export_item_profile as "profile-editors.export_item_profile" }